<div class="container-md position-relative">
  <span class="slime position-absolute"></span>
</div>
